// removed by extract-text-webpack-plugin
module.exports = {"container":"_117Ds","content":"_3fJke","textArea":"_3Y29f","saveButton":"_3mJrc","hidden":"_2ul4R","uploadButton":"_1RRHB","fileInput":"_2qme3","buttonContainer":"_2GHXG"};


//////////////////
// WEBPACK FOOTER
// ./app/components/comment-bar/comment-bar.scss
// module id = 1731
// module chunks = 0